import Controller from "@ember/controller";
import AnonymousEmailLog from "../../models/admin-plugins-anonymous-email-log";
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";

export default class AdminPluginsAnonymousEmailLogController extends Controller {
  @tracked loading = false;

  @action
  loadLogs(loadMore) {
    if ((loadMore && this.loading) || this.model?.allLoaded) {
      return;
    }

    this.loading = true;
    return AnonymousEmailLog.findAll(loadMore ? this.model?.length : null)
      .then((logs) => {
        if (this.model && loadMore && logs.length < 50) {
          this.model.allLoaded = true;
        }

        if (this.model && loadMore) {
          this.model = [...this.model, ...logs];
        } else {
          this.model = logs;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @action
  loadMore() {
    this.loadLogs(true);
  }
}
